export const datetimeOptionsGB = {
  day: '2-digit', month: '2-digit', year: 'numeric',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
};

export const fmtDateTimeGB = (v) =>
  new Date(v).toLocaleString('en-GB', {
    ...datetimeOptionsGB,
    timeZone: 'UTC',
  });

export const toIsoDate = (d) => {
  const dt = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
  return dt.toISOString().slice(0, 10);
};

export const makeDefaultDateRange21 = () => {
  const today = new Date();
  const start = new Date();
  start.setDate(today.getDate() - 20);
  return { start: toIsoDate(start), end: toIsoDate(today) };
};
